export default function cancelModal(query) {
	if (query.get('fromModal')) {
		query.set('modal', query.get('fromModal'));
		if (query.has('req_id')) {
			query.set('id', query.get('req_id'));
		}
		if (query.has('fromTab')) {
			query.set('tab', query.get('fromTab'));
		}
		if (query.has('fromId')) {
			query.set('id', query.get('fromId'));
		}
	} else {
		query.delete('modal');
		query.delete('id');
	}
	query.delete('mode');
	query.delete('fromModal');
	query.delete('fromId');
	query.delete('pointId');
	query.delete('req_id');
	query.delete('fromTab');
	query.delete('contactsSearch');
	query.delete('childrenSorts');
	query.delete('childrenFilters');
	query.delete('modalSorts');
	query.delete('modalFilters');
	query.delete('express');
	query.delete('process_id');
	query.delete('addressId');
}
